<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">



                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-share text-info mr-1"></i>
                                        Assign
                                        <b-badge v-if="selection.length > 0" id="selection" variant="primary"
                                            class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip v-if="selection.length > 0" target="selection" placement="bottom">{{
                                            selection.length }} ticket(s)
                                            selected</b-tooltip>
                                    </div>

                                </template>

                                <p class="mt-2">

                                    <b-row class="my-2">
                                        <b-col cols="12" sm="6" md="4">
                                            <b-form-group label-cols="12" label="Date" label-size="sm">
                                                <!-- <b-input-group>
                                                    <v-date-picker v-model="date_at" mode="date" is24hr color="green"
                                                        :locale="'en-gb'" class="form-control form-control-sm">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <input class="
                                                                    h-19px
                                                                    border-none
                                                                    focus:outline-none focus:border-primary
                                                                    text-primary
                                                                    " :value="inputValue" v-on="inputEvents" />
                                                        </template>
                                                    </v-date-picker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" squared variant="outline-secondary"
                                                            :disabled="!date_at" @click="date_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group> -->

                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="date_at" v-model="date_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :single-date-picker="'true'">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="date_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }
                                                            ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="8">
                                            <b-form-group label-cols="12" label="Ticket(s) Assignment"
                                                label-for="reasontype">

                                                <b-form-radio-group class="mt-1" id="reasontype" v-model="reasontype"
                                                    :options="options_reasontype" name="reasontype"
                                                    @change="reasontype_change"></b-form-radio-group>

                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                    <b-row class="mt-2">
                                        <b-col cols="12" sm="4">
                                            <b-form-group label-cols="12" label="Ticket(s) selected" label-size="sm"
                                                class="mb-0">

                                                <b-input-group>
                                                    <b-form-tags input-id="ticketno" v-model="ticketno"
                                                        tag-variant="primary" separator=" ,;" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"
                                                        :disabled="true"></b-form-tags>

                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="ticketno = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>
                                    </b-row>

                                </p>

                            </b-tab>
                            <b-tab v-if="reasontype.includes('allocated')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Allocated</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            Tickets will be checked against the system for their accounts allocation
                                            status.
                                            Tickets that are allocated have already been entered into the Bought Ledger.
                                            Unallocated tickets are currently unaccounted for.<br /><br />
                                            When synchronising Zhold, Allocated tickets will be removed from Zhold using
                                            the
                                            details found, Unallocated tickets will be cleared for invoicing and make it
                                            available for the agents to invoice.
                                        </b-col>

                                    </b-row>

                                <div class="px-0">
                                    <d-table classdivtable="availtable datatable nested" refid="allocation"
                                        :icon="allocation.icon" :toolbarlibrary="allocation.toolbarlibrary"
                                        :tools="allocation.tools" :badges="allocation.badges"
                                        :fields="allocation.fields" :items="allocation.items" :busy="allocation.busy"
                                        :page="allocation.page" :showpages="false" @load="allocation_load"
                                        @click="allocation_click" @select="allocation_select" :showrowcount="false">
                                    </d-table>
                                </div>
                                <b-row>
                                    <b-col cols="auto">
                                        <b-form-checkbox id="applyzhold" v-model="applyzhold" name="applyzhold"
                                            value="1" unchecked-value="0">
                                            Synchronise Zhold
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-form-checkbox id="applyallocate" v-model="applyallocate" name="applyallocate"
                                            value="1" unchecked-value="0">
                                            Use IN: to remove from Zhold
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                                </p>

                            </b-tab>


                            <b-tab v-if="reasontype.includes('sales')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Sales</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            All tickets in the selection will be validated and entered into the Sales
                                            ledger
                                            with the pricing details below. Costs will also be entered into the Bought
                                            ledger. It is also possible to change the Event, Client and Your Ref/PO for
                                            all
                                            tickets.
                                        </b-col>

                                    </b-row>
                                    <b-row>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="yourref"
                                                        placeholder="Your Ref / PO" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col>
                                            <d-table classdivtable="availtable datatable nested" refid="sllines"
                                                :icon="sllines.icon" :selectmode="'single'" :busy="sllines.busy"
                                                :tools="sllines.tools" :badges="sllines.badges" :fields="sllines.fields"
                                                :items="sllines.items" :page="sllines.page" :showpages="false"
                                                @load="sllines_load" @click="sllines_click" @select="sllines_select"
                                                :tableheight="230">
                                            </d-table>
                                        </b-col>
                                    </b-row>

                                    <b-row v-if="sllines.item.id" class="mt-3">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <!-- <b-form-group
                                                    v-if="sllines.item.blac == 'VOLANTEUS' || sllines.item.blac == 'BSP'"
                                                    label-cols="12" label="TicketNo" label-size="sm">
                                                    <treeselect placeholder="Select ticketno..."
                                                        searchPromptText="Type at least 6 chars..."
                                                        v-model="sllines.item.ticketno" :clearable="true" :multiple="true"
                                                        :async="true" :load-options="treeselect_loadTicket"
                                                        :show-count="true" :flatten-search-results="true"
                                                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                        :disabled="readonly">
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>
                                                </b-form-group> -->

                                            <b-form-group label="TicketNo" label-for="ticketno" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.ticketno"
                                                        placeholder="Ticketno" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.ticketno = ''" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Passenger" label-for="passenger" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.passenger"
                                                        placeholder="Passenger" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.passenger = ''" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Route" label-for="route" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.route"
                                                        placeholder="Route" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.route = ''" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="DateTravel" label-size="sm">
                                                <b-input-group>
                                                    <v-date-picker v-model="sllines.item.datetravel" mode="date" is24hr
                                                        color="green" :locale="'en-gb'"
                                                        class="form-control form-control-sm" :disabled="readonly">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <input :disabled="readonly" class="h-19px border-none
                                                                            focus:outline-none focus:border-primary
                                                                            text-primary" :value="inputValue"
                                                                v-on="inputEvents" />
                                                        </template>
                                                    </v-date-picker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" squared variant="outline-secondary"
                                                            :disabled="readonly"
                                                            @click="sllines.item.datetravel = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="9">
                                            <b-form-group label="More Info" label-for="moreinfo" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.moreinfo"
                                                        placeholder="More Info" size="sm"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="readonly"
                                                            variant="outline-secondary"
                                                            @click="sllines.item.moreinfo = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Remark" label-for="remark" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.remark"
                                                        placeholder="Remark" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.remark = ''" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Qty" label-for="qty" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="number" :min="min_qty" :max="max_qty"
                                                        v-model="sllines.item.qty" placeholder="Qty" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.qty = '0'" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Price Ex VAT" label-for="lineprice"
                                                label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.lineprice"
                                                        placeholder="Unit Price Ex VAT" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.lineprice = '0.00'"
                                                            :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Taxes" label-for="linetaxes" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.linetaxes"
                                                        placeholder="Unit Taxes" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.linetaxes = '0.00'"
                                                            :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Subtotal Ex VAT" label-for="linesubtotal"
                                                label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.linesubtotal"
                                                        placeholder="Unit Subtotal Ex VAT" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.linesubtotal = '0.00'"
                                                            :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Fees" label-for="linefees" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.linefees"
                                                        placeholder="Unit Fees" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.linefees = '0.00'"
                                                            :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit VAT" label-for="linevat" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sllines.item.linevat"
                                                        placeholder="Unit VAT" size="sm" trim
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.linevat = '0.00'" :disabled="readonly">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Total" label-for="linetotal" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" :debounce="500"
                                                        v-model="sllines.item.linetotal" placeholder="Unit Total"
                                                        size="sm" trim :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="sllines.item.linetotal = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..."
                                                    v-model="sllines.item.blac" :clearable="true" :async="true"
                                                    :load-options="treeselect_loadBLAC" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>


                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Unit Price Ex Vat" label-for="priceexvat" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="priceexvat"
                                                        placeholder="Unit Price Ex Vat" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                            @click="priceexvat = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Sale Ex Vat" label-for="saleexvat" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="saleexvat" placeholder="Sale Ex Vat"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                            @click="saleexvat = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Sale Total" label-for="saletotal" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="saletotal" placeholder="Sale Total"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                            @click="saletotal = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" md="5" class="mt-4">
                                            <b-form-checkbox id="groupfares" v-model="groupfares" name="groupfares"
                                                value="true" unchecked-value="false" :disabled="true">
                                                Group all fares as one single total
                                            </b-form-checkbox>
                                        </b-col> -->




                                </p>
                            </b-tab>

                            <b-tab v-if="reasontype.includes('sales')">
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>Draft
                                </template>

                                <div class="etr">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary"
                                                rounded="sm">
                                                <!-- {{ selection }} -->
                                                <!-- <r-invoice :showasdraft="true" :item="draft" />

                                            <b-alert v-if="draft.message" show :variant="draft.level"
                                                class="text-center mt-2 mb-1">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                    <b-col> <span
                                                            v-html="draft.message.split('\n').join('<br/>')"></span></b-col></b-row>
                                            </b-alert> -->

                                            </b-overlay>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab>

                            <b-tab v-if="reasontype.includes('costs')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Costs</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            The following tickets will be validated and entered into the Bought Ledger.
                                            <!-- {{data}} -->
                                        </b-col>

                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <d-table classdivtable="availtable datatable nested" refid="bllines"
                                                :icon="bllines.icon" :selectmode="'single'" :busy="bllines.busy"
                                                :tools="bllines.tools" :badges="bllines.badges" :fields="bllines.fields"
                                                :items="bllines.items" :page="bllines.page" :showpages="false"
                                                @load="bllines_load" @click="bllines_click" @select="bllines_select"
                                                @totalled="bllines_total">
                                            </d-table>
                                        </b-col>
                                    </b-row>

                                    <b-tabs v-if="bllines.item.line" class="gridtabs mt-2">


                                        <b-tab>


                                            <template #title>
                                                <span class="text-primary">{{bllines.items.map(o =>
                                                    o.line).indexOf(bllines.item.line) + 1
                                                    }}.</span>
                                                <i :class="'fa fa fa-arrows-h text-info'"
                                                    class="text-primary ml-1 mr-1"></i>
                                                <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                    : "edit" }}&gt;</span>&nbsp;


                                            </template>

                                            <p class="py-3 px-0">
                                                <b-row>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Ticket No/Ref"
                                                            label-size="sm">
                                                            <b-input-group>
                                                                <b-form-input v-model="bllines.item.ticketno"
                                                                    :debounce="bllines.debounce" placeholder="Ticket No"
                                                                    :disabled="bllines_readonly"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        :disabled="bllines_readonly"
                                                                        @click="bllines.item.ticketno = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Passenger / Comments"
                                                            label-size="sm">
                                                            <b-input-group>
                                                                <b-form-input v-model="bllines.item.passenger"
                                                                    :debounce="bllines.debounce"
                                                                    placeholder="Name / Comments"
                                                                    :disabled="bllines_readonly"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        :disabled="bllines_readonly"
                                                                        @click="bllines.item.passenger = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Route" label-for="route" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="bllines.item.route"
                                                                    placeholder="Route" size="sm" trim
                                                                    :disabled="bllines_readonly"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bllines.item.route = ''"
                                                                        :disabled="bllines_readonly">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Remark" label-for="remark" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" placeholder="Remark" size="sm"
                                                                    trim :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bllines.item.remark = ''"
                                                                        :disabled="true">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <!-- {{ datetravel }}
                                                    {{ bllines.item.datetravel }} -->
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="DateTravel"
                                                            label-size="sm">
                                                            <b-input-group>
                                                                <v-date-picker v-model="datetravel" mode="date" is24hr
                                                                    color="green" :locale="'en-gb'"
                                                                    class="form-control form-control-sm"
                                                                    :disabled="readonly">
                                                                    <template v-slot="{ inputValue, inputEvents }">
                                                                        <input :disabled="bllines_readonly" class="h-19px border-none
                                                                                focus:outline-none focus:border-primary
                                                                                text-primary" :value="inputValue"
                                                                            v-on="inputEvents" />
                                                                    </template>
                                                                </v-date-picker>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" squared
                                                                        variant="outline-secondary"
                                                                        :disabled="bllines_readonly"
                                                                        @click="datetravel = null">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>



                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Supplier B/L"
                                                            label-size="sm">
                                                            <treeselect placeholder="Select blac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="bllines.item.blac" :clearable="true"
                                                                :async="true" :load-options="treeselect_loadBLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested :disabled="bllines_readonly">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="BSP Ref" label-for="bspref"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="bllines.item.bspref"
                                                                    placeholder="BSP Ref" size="sm"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="true"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.bspref = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="QTY" label-for="qty" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="bllines.item.qty"
                                                                    placeholder="QTY" size="sm"
                                                                    :disabled="bllines_readonly"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="bllines_readonly"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.qty = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Cost Ex VAT" label-for="costexvat"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bllines.item.costexvat" placeholder="Cost"
                                                                    size="sm" :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="true"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.costexvat = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Cost VAT" label-for="vat" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="bllines.item.costvat"
                                                                    placeholder="VAT" size="sm"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="true"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.costvat = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Taxes" label-for="taxes" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="bllines.item.taxes"
                                                                    placeholder="Taxes" size="sm"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="true"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.taxes = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Cost Total" label-for="costtotal"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bllines.item.costtotal"
                                                                    placeholder="Cost Total" size="sm"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" :disabled="true"
                                                                        variant="outline-secondary"
                                                                        @click="bllines.item.costtotal = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Client SL A/C"
                                                            label-size="sm">
                                                            <treeselect placeholder="Select slac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="bllines.item.slac" :clearable="true"
                                                                :async="true" :load-options="treeselect_loadSLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested :disabled="readonly">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Event" label-size="sm">
                                                            <treeselect placeholder="Select event..."
                                                                v-model="bllines.item.eventcode" :clearable="true"
                                                                :async="true" :load-options="treeselect_loadEvent"
                                                                searchPromptText="Type at least 4 chars..."
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested :disabled="readonly">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-form-group>
                                                    </b-col>

                                                </b-row>



                                            </p>

                                        </b-tab>

                                    </b-tabs>

                                </p>

                            </b-tab>


                            <b-tab v-if="reasontype.includes('emds')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    EMDs</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            Select the spreadsheet to analyse, we will check the sheet and validate the
                                            ticket numbers to determine if EMDs can be invoiced.
                                        </b-col>

                                    </b-row>

                                    <b-card-body class="py-0 px-0">
                                        <div>
                                            <b-row>
                                                <b-col cols="12" sm="6" md="6" xl="6">
                                                    <b-form-group
                                                        label="Click x to remove or browse for document upload..."
                                                        label-size="sm">
                                                        <b-input-group>

                                                            <b-input-group-prepend>
                                                                <b-button size="sm" title="delete"
                                                                    variant="outline-danger" @click="fileUpload_clear">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-file class="ml-1 z-0" id="file-small" size="sm"
                                                                ref="file-input" :multiple="false" no-drop
                                                                @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                                    "
                                                                :disabled="fileUpload ? true : false"></b-form-file>
                                                            <b-input-group-append>
                                                                <b-button class="ml-1" size="sm" title="view file"
                                                                    variant="outline-primary" @click="fileUpload_view"
                                                                    :disabled="!fileUpload">
                                                                    <i class="fa fa-download"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-row>
                                                        <b-col>
                                                            <b-form-group label="Type" label-for="type" label-cols="12">
                                                                <treeselect instanceId="type" type="number"
                                                                    v-model="item.type" :clearable="true"
                                                                    :options="type_options" :disabled="true">
                                                                </treeselect>
                                                            </b-form-group></b-col>
                                                        <b-col>
                                                            <b-form-group label="Size" label-for="size" label-cols="12">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.size"
                                                                        placeholder="Enter size" size="sm"
                                                                        :disabled="true"></b-form-input>

                                                                </b-input-group> </b-form-group></b-col>

                                                    </b-row>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Source Filter" label-for="sourcetype"
                                                        label-cols="12">
                                                        <b-form-input v-model="sourcetype" size="sm" :disabled="true"
                                                            placeholder="Not detected">
                                                        </b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary"
                                            rounded="sm">
                                            <r-table :refid="emd.refid" :busy="emd.busy" :icon="emd.icon"
                                                :showtoolbar="true" :showsheets="true" :showpages="false"
                                                :showfab="false" :tools="emd.tools" :toolbar="emd.toolbar"
                                                :fields="emd.fields" :items="emd.items" :dirty="emd.dirty"
                                                @click="emd_click" @select="emd_select" />

                                            <b-row class="px-0 mt-3">
                                                <b-col>
                                                    <b-alert :show="message_sheet != null" variant="danger">
                                                        <b-row no-gutters align-v="center">
                                                            <b-col cols="auto" class="mr-3">
                                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                            <b-col>
                                                                <span v-html="message_sheet"></span></b-col></b-row>
                                                    </b-alert></b-col>
                                            </b-row>


                                        </b-overlay>

                                    </b-card-body>
                                </p>

                            </b-tab>

                            <b-tab v-if="reasontype.includes('refunds')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Refunds</template>

                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            Select the spreadsheet to analyse, we will check the sheet and validate the
                                            ticket numbers to determine if refunds can be processed.
                                        </b-col>

                                    </b-row>
                                    <b-card-body class="py-0 px-0">
                                        <div>
                                            <b-row>
                                                <b-col cols="12" sm="6" md="6" xl="6">
                                                    <b-form-group
                                                        label="Click x to remove or browse for document upload..."
                                                        label-size="sm">
                                                        <b-input-group>

                                                            <b-input-group-prepend>
                                                                <b-button size="sm" title="delete"
                                                                    variant="outline-danger" @click="fileUpload_clear">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-file class="ml-1 z-0" id="file-small" size="sm"
                                                                ref="file-input" :multiple="false" no-drop
                                                                @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                                    "
                                                                :disabled="fileUpload ? true : false"></b-form-file>
                                                            <b-input-group-append>
                                                                <b-button class="ml-1" size="sm" title="view file"
                                                                    variant="outline-primary" @click="fileUpload_view"
                                                                    :disabled="!fileUpload">
                                                                    <i class="fa fa-download"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-row>
                                                        <b-col>
                                                            <b-form-group label="Type" label-for="type" label-cols="12">
                                                                <treeselect instanceId="type" type="number"
                                                                    v-model="item.type" :clearable="true"
                                                                    :options="type_options" :disabled="true">
                                                                </treeselect>
                                                            </b-form-group></b-col>
                                                        <b-col>
                                                            <b-form-group label="Size" label-for="size" label-cols="12">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.size"
                                                                        placeholder="Enter size" size="sm"
                                                                        :disabled="true"></b-form-input>

                                                                </b-input-group> </b-form-group></b-col>

                                                    </b-row>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Source Filter" label-for="sourcetype"
                                                        label-cols="12">
                                                        <b-form-input v-model="sourcetype" size="sm" :disabled="true"
                                                            placeholder="Not detected">
                                                        </b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary"
                                            rounded="sm">

                                            <r-table :refid="refund.refid" :busy="refund.busy" :icon="refund.icon"
                                                :showtoolbar="true" :showsheets="true" :showpages="false"
                                                :showfab="false" :tools="refund.tools" :toolbar="refund.toolbar"
                                                :fields="refund.fields" :items="refund.items" :dirty="refund.dirty"
                                                @click="refund_click" @select="refund_select" />

                                        </b-overlay>

                                        <b-row class="px-0 mt-3">
                                            <b-col>
                                                <b-alert :show="message_sheet != null" variant="danger">
                                                    <b-row no-gutters align-v="center">
                                                        <b-col cols="auto" class="mr-3">
                                                            <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                        <b-col>
                                                            <span v-html="message_sheet"></span></b-col></b-row>
                                                </b-alert></b-col>
                                        </b-row>
                                    </b-card-body>
                                </p>

                            </b-tab>

                            <b-tab v-if="reasontype.includes('other')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Other</template>

                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            Select the spreadsheet to analyse, we will check the sheet and validate it.
                                        </b-col>

                                    </b-row>
                                    <b-card-body class="py-0 px-0">
                                        <div>
                                            <b-row>
                                                <b-col cols="12" sm="6" md="6" xl="6">
                                                    <b-form-group
                                                        label="Click x to remove or browse for document upload..."
                                                        label-size="sm">
                                                        <b-input-group>

                                                            <b-input-group-prepend>
                                                                <b-button size="sm" title="delete"
                                                                    variant="outline-danger" @click="fileUpload_clear">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-file class="ml-1 z-0" id="file-small" size="sm"
                                                                ref="file-input" :multiple="false" no-drop
                                                                @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                                    "
                                                                :disabled="fileUpload ? true : false"></b-form-file>
                                                            <b-input-group-append>
                                                                <b-button class="ml-1" size="sm" title="view file"
                                                                    variant="outline-primary" @click="fileUpload_view"
                                                                    :disabled="!fileUpload">
                                                                    <i class="fa fa-download"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-row>
                                                        <b-col>
                                                            <b-form-group label="Type" label-for="type" label-cols="12">
                                                                <treeselect instanceId="type" type="number"
                                                                    v-model="item.type" :clearable="true"
                                                                    :options="type_options" :disabled="true">
                                                                </treeselect>
                                                            </b-form-group></b-col>
                                                        <b-col>
                                                            <b-form-group label="Size" label-for="size" label-cols="12">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.size"
                                                                        placeholder="Enter size" size="sm"
                                                                        :disabled="true"></b-form-input>

                                                                </b-input-group> </b-form-group></b-col>

                                                    </b-row>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Source Filter" label-for="sourcetype"
                                                        label-cols="12">
                                                        <b-form-input v-model="sourcetype" size="sm" :disabled="true"
                                                            placeholder="Not detected">
                                                        </b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary"
                                            rounded="sm">

                                            <r-table :refid="other.refid" :busy="other.busy" :icon="other.icon"
                                                :showtoolbar="true" :showsheets="true" :showpages="false"
                                                :showfab="false" :tools="other.tools" :toolbar="other.toolbar"
                                                :fields="other.fields" :items="other.items" :dirty="other.dirty"
                                                @click="other_click" @select="other_select" />



                                        </b-overlay>

                                        <b-row class="px-0 mt-3">
                                            <b-col>
                                                <b-alert :show="message_sheet != null" variant="danger">
                                                    <b-row no-gutters align-v="center">
                                                        <b-col cols="auto" class="mr-3">
                                                            <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                        <b-col>
                                                            <span v-html="message_sheet"></span></b-col></b-row>
                                                </b-alert></b-col>
                                        </b-row>
                                    </b-card-body>
                                </p>

                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()" :disabled="posted"
                                    v-if="tabindex != 0 && (user.permissions.includes('tickets.save') || user.permissions.includes('boughtledger.save'))">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "TicketsAssign",
    async mounted() {
        await this.accessdenied();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            applyzhold: false,
            applyallocate: false,
            posted: true,
            readonly: false,
            message: null,
            message_sheet: null,
            textsize: "",
            data: [],
            bllines_readonly: true,
            sllines_readonly: true,
            groupfares: false,
            ticketno: [],
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            datetravel: null,
            yourref: null,
            slac: null,
            eventcode: null,
            priceexvat: null,
            saleexvat: null,
            reason: null,
            reasontype: [],
            options_reasontype: [
                { text: 'Allocated', value: 'allocated' },
                { text: 'Sales', value: 'sales' },
                { text: 'Costs', value: 'costs' },
                { text: 'EMDs', value: 'emds' },
                { text: 'Refunds', value: 'refunds' },
                { text: 'Other', value: 'other' },
            ],
            upload: null,
            type_options: [
                { id: 0, label: "File" },
                { id: 1, label: "File folder" },
            ],
            sourcetype: null,
            sourcetype_options: [
                { id: "0", label: "Bulkticket0" },
                { id: "1", label: "Bulkticket1" },
                { id: "2", label: "BarclayCard" },
                { id: "3", label: "ConfermaPay" },
            ],
            allocation: {
                title: "Allocation",
                icon: "fa fa-ticket text-orange",
                debounce: 500,
                busy: false,
                page: 1,
                denied: [],
                toolbarlibrary: [],
                tools:
                    "go,export,clipboard",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "dateissued",
                        label: "Issued",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "carrier_id",
                        label: "Al",
                        sortable: true,
                        class: "d-none d-xl-table-cell text-center",
                    },

                    {
                        key: "ticketno",
                        label: "Ticket No",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "passenger",
                        label: "Name",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center",
                         formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "routing",
                        label: "Routing",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 12) {
                                    result = result.slice(0, 12) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "flightno",
                        label: "FlightNo",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 14) {
                                    result = result.slice(0, 14) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "class",
                        label: "Class",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                    },
                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "Invoice No",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "text-right",
                    },
                ],
                badges: [
                    {
                        key: "carrier_id",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "ticketno",
                        type: "pill",
                        class: "orange",
                    },
                    {
                        key: "class",
                        type: "pill",
                        class: "purple",
                        title: "classname",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "lines",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "type",
                        type: "badge",
                        Charter: "teal",
                        Ticket: "primary",
                        Reissue: "primary",
                        Void: "white",
                        Refund: "white",
                        EMD: "purple",
                    },
                    {
                        key: "fare_type",
                        type: "badge",
                        Unknown: "white",
                        Negotiated: "warning",
                        Net: "purple",
                        Manual: "secondary",
                        Published: "white",
                        Private: "pink",
                        other: "secondary",
                        formatter: (value, key, item) => {
                            switch (parseInt(value)) {
                                case "Unknown":
                                    return "Unknown";
                                    break;
                                case "Negotiated":
                                    return "Negotiated";
                                    break;
                                case "Net":
                                    return "Net";
                                    break;
                                case "Manual":
                                    return "Manual";
                                    break;
                                case "Published":
                                    return "Published";
                                    break;
                                case "Private":
                                    return "Private";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "status",
                        type: "pill",
                        class: "white",
                    },
                ],
                items: [],
                selected: [],
            },
            bllines: {
                title: "Lines",
                icon: "fa fa-list text-info",
                debounce: 500,
                busy: false,
                tools: "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                    },
                    {
                        key: "datetravel",
                        label: "DateTravel",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },
                    {
                        key: "ticketno",
                        label: "TicketNo",
                        sortable: true,
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "route",
                        label: "Route",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "qty",
                        label: "Qty",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //     key: "fees",
                    //     label: "Fees",
                    //     sortable: true,
                    //     class: "text-right",
                    //     total: 0,
                    //     totalled: true,
                    // },
                    {
                        key: "costexvat",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "taxes",
                        label: "Taxes",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "costtotal",
                        label: "Subtotal",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "text-right",
                    },
                ],
                badges: [
                    {
                        key: "status",
                        type: "pill",
                        class: "white",
                    },
                ],
                item: {},
                items: [],
                selected: []
            },
            sllines: {
                title: "Lines",
                icon: "fa fa-list text-info",
                debounce: 500,
                busy: false,
                tools: "go,export,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    // {
                    //     key: "fare",
                    //     label: "Fare",
                    //     sortable: true,
                    // },
                    {
                        key: "ticketno",
                        label: "TicketNo",
                        sortable: true,
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "route",
                        label: "Route",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "datetravel",
                        label: "DateTravel",
                        sortable: true,
                        // formatter: (value, key, item) => {
                        //     let result = "";
                        //     if (value) {
                        //         result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                        //     }
                        //     return result;
                        // },
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },

                    {
                        key: "qty",
                        label: "Qty",
                        sortable: true,
                        class: "text-right",
                    },

                    {
                        key: "lineprice",
                        label: "Unit Price Ex VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetaxes",
                        label: "Unit Taxes",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },

                    {
                        key: "linesubtotal",
                        label: "Sale Ex VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linefees",
                        label: "Unit Fees",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    // {
                    //     key: "linesubtotal",
                    //     label: "SubTotal Ex VAT",
                    //     sortable: true,
                    //     class: "text-right",
                    //     total: 0,
                    //     totalled: true,
                    // },
                    {
                        key: "linevat",
                        label: "Line VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetotal",
                        label: "Line Total",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    // {
                    //     key: "updated_by",
                    //     label: "Updated By",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "updated_at",
                    //     label: "Updated At",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                    // {
                    //     key: "eventcode",
                    //     label: "Event",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "slac",
                    //     label: "SL A/C",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "yourref",
                    //     label: "Your Ref/PO",
                    //     sortable: true,
                    //     class: "text-center d-none d-sm-table-cell",
                    //     formatter: (value, key, item) => {
                    //         let result = value;
                    //         if (result) {
                    //             if (result.length > 12) {
                    //                 result = result.slice(0, 9) + "...";
                    //             }
                    //         }
                    //         return result;
                    //     },
                    // },
                    // {
                    //     key: "invoiceno",
                    //     label: "InvoiceNo",
                    //     sortable: true,
                    // },
                    // {
                    //     key: "status",
                    //     label: "Status",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px w-sm-100pct",
                    },
                ],
                badges: [
                    {
                        key: "status",
                        type: "badge",
                        Queued: "primary",
                        Posted: "primary",
                        Pending: "warning",
                        Exists: "danger",
                    },
                ],
                item: {},
                items: [],
                selected: []
            },
            state: null,
            emd: {
                title: "EMD Sheet Import",
                icon: "fa fa-cloud-upload",
                debounce: 500,
                busy: false,
                dirty: false,
                page: 1,
                tools: "go,export,copy,textsize,error,missing,void,invoiced,pending,sheet_1",
                toolbar: [],
                fields: [],
                items: [],
                loaded: []
            },
            refund: {
                title: "Refund Sheet Import",
                icon: "fa fa-cloud-upload",
                debounce: 500,
                busy: false,
                dirty: false,
                page: 1,
                tools: "go,export,copy,textsize,error,missing,credited,pending,sheet_1",
                toolbar: [],
                fields: [],
                items: [],
                loaded: []
            },
            other: {
                title: "Sheet Import",
                icon: "fa fa-cloud-upload",
                debounce: 500,
                busy: false,
                dirty: false,
                page: 1,
                tools: "go,export,copy,textsize,ban,missing,invoiced,zhold,sheet_1",
                toolbar: [],
                fields: [],
                items: [],
                loaded: []
            },
            item: {
            },
            sheets: [],
        };
    },
    watch: {
        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal == 2) {
                    // await this.sllines_renderit()
                }
            }
        },
        eventcode: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.sllines_load()
            },
        },
        slac: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.sllines_load()
            },
        },
        yourref: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.sllines_load()
            },
        },
        priceexvat: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.sllines_load()
            },
        },
        saleexvat: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.sllines_load()
            },
        },
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.state = null
                this.activesheet.fields = []
                this.activesheet.items = []
                this.item.type = 0;
                if (newVal) {
                    this.item.name = newVal.name;
                    this.item.size = newVal.size;
                    await this.preview(JSON.stringify(newVal));
                } else {
                    this.item.name = null;
                    this.item.size = 0;
                    this.message_sheet = null
                }
            },
        },
        "item.name": {
            async handler(newVal, oldVal) {
                if (this.fileUpload) {
                    this.fileUpload.name = newVal;
                }
            },
        },
        applyzhold: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.posted = !newVal
            },
        },
        applyallocate: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.posted = !newVal
            },
        }
    },
    computed: {
        activesheet() {
            if (this.sourcetype == "REFUND") {
                return this.refund
            } else if (this.sourcetype == "EMD") {
                return this.emd
            } else {
                return this.other
            }
        }
    },
    methods: {
        async accessdenied() {
            if (!this.user.permissions.includes("boughtledger.save")) {
                this.options_reasontype = this.options_reasontype.filter(e => e.value !== 'costs')
            }
            if (!this.user.permissions.includes("salesledger.save")) {
                this.options_reasontype = this.options_reasontype.filter(e => e.value !== 'sales')
            }
        },
        async load() {
            this.ticketno = []
            for (var i = 0; i < this.selection.length; ++i) {
                this.ticketno.push(this.selection[i].ticketno)
            }
            // for (var i = 0; i < this.options_reasontype.length; ++i) {
            //     this.options_reasontype[i].disabled = true
            // }
        },
        async reasontype_change(v) {

            switch (v) {
                case "allocated":
                    await this.allocation_load();
                    this.tabindex = 1
                    break;
                case "sales":
                    await this.sllines_load();
                    this.posted = !this.sllines.items.length > 0
                    // this.tabindex = 1
                    break;
                case "costs":
                    await this.bllines_load();
                    this.posted = !this.bllines.items.length > 0
                    this.tabindex = 1
                    break;
                case "refunds":
                    this.sourcetype = "REFUND"
                    this.posted = true
                    this.tabindex = 1
                    break;
                case "emds":
                    this.sourcetype = "EMD"
                    this.posted = true
                    this.tabindex = 1
                    break;
                case "other":
                    this.sourcetype = "OTHER"
                    this.posted = true
                    this.tabindex = 1
                    break;
            }
            this.state = null
            this.activesheet.fields = []
            this.activesheet.items = []
            this.fileUpload_clear()
        },

        async allocation_load(offset, limit, page) {

            this.allocation.busy = true
            let variables = {
                selected: this.cleanit(this.selection)
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation tickets_allocated($selected: [Ticket_input]) {
                        tickets_allocated(selected: $selected) {
                            id
                            dateissued
                            type
                            locator
                            carrier_id
                            ticketno
                            passenger
                            datetravel
                            routing
                            flightno
                            class
                            fare
                            tax
                            slac
                            eventcode
                            agent
                            invoiceno
                            status
                        }
                    }
            `,
                    variables,
                });
                this.allocation.items = response.data.tickets_allocated

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.allocation.busy = false
        },
        async allocation_click(a, ss) {
            console.log("allocation_click", a, ss);

            let state = this.allocation;

            switch (a) {

                case "go":
                    this.component = null;
                    await this.allocation_load();
                    break;

            }
        },
        async allocation_select(ss, tools) {
            console.log("allocation_select", ss);

            let state = this.allocation;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "clipboard", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                // state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.dateref = this.$moment.unix(state.item.dateref * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.datedepart = this.$moment.unix(state.item.datedepart * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }
        },

        async sllines_load(offset, limit, page) {

            if (this.selection.lengh == 0) { return }

            this.saletotal = 0

            this.sllines.busy = true;

            let variables = {
                selected: this.cleanit(this.selection)
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation tickets_sales($selected: [Ticket_input]) {
                        tickets_sales(selected: $selected) {
                            id
                            entry
                            line
                            blac
                            ticketno
                            route
                            moreinfo
                            remark
                            slac 
                            passenger   
                            datetravel
                            qty
                            lineprice
                            linetaxes
                            linesubtotal
                            linefees
                            linevat
                            linetotal                            
                        }
                    }
            `,
                    variables,
                });
                this.sllines.items = response.data.tickets_sales

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }



            // this.sllines.items = [];
            // for (var i = 0; i < this.selection.length; ++i) {
            //     let item = { ...this.selection[i] }

            //     if (this.eventcode) {
            //         item.eventcode = this.eventcode
            //     }
            //     if (this.slac) {
            //         item.slac = this.slac
            //     }
            //     if (this.yourref) {
            //         item.yourref = this.yourref
            //     }

            //     if (this.priceexvat) {
            //         item.priceexvat = parseFloat(this.priceexvat).toFixed(2)
            //     } else {
            //         item.priceexvat = parseFloat(item.fare).toFixed(2)
            //     }
            //     item.fees = parseFloat(0).toFixed(2)

            //     if (this.saleexvat) {
            //         item.saleexvat = parseFloat(this.saleexvat).toFixed(2)
            //         item.priceexvat = (parseFloat(item.saleexvat) - parseFloat(item.tax)).toFixed(2)
            //     } else {
            //         item.saleexvat = (parseFloat(item.priceexvat) + parseFloat(item.tax)).toFixed(2)
            //     }
            //     item.subtotalexvat = (parseFloat(item.saleexvat) + parseFloat(item.fees)).toFixed(2)
            //     item.salevat = parseFloat(0).toFixed(2)
            //     item.saletotal = (parseFloat(item.subtotalexvat) + parseFloat(item.salevat)).toFixed(2)

            //     this.sllines.items.push({
            //         id: item.id,
            //         line: (i + 1).toString(),
            //         blac: item.blac,
            //         slac: item.slac,
            //         eventcode: item.eventcode,
            //         yourref: item.yourref,
            //         ticketno: item.ticketno,
            //         passenger: item.passenger,
            //         route: item.routing,
            //         datetravel: item.datetravel,
            //         qty: "1",
            //         lineprice: item.priceexvat,
            //         linetaxes: item.tax,
            //         linesubtotal: item.saleexvat,
            //         linefees: item.fees,
            //         subtotalexvat: item.subtotalexvat,
            //         linevat: item.salevat,
            //         linetotal: item.saletotal,
            //         agent: item.agent,
            //         updated_by: item.updated_by,
            //         updated_at: item.updated_at,
            //     })

            //     this.saletotal += parseFloat(item.saletotal)
            // }
            // this.saletotal = (this.saletotal).toFixed(2)

            // this.scrollToRow(this.selection.length - 1)
            this.sllines.busy = false;
        },

        async sllines_click(a, ss) {
            console.log("sllines_click", a, ss);

            let state = this.sllines;

            switch (a) {

                case "go":
                    this.component = null;
                    this.eventcode = null
                    this.slac = null
                    this.yourref = null
                    this.priceexvat = null
                    this.saleexvat = null
                    await this.sllines_load();
                    break;

                case "save":
                    await this.sllines_saveit()
                    break;

            }
        },
        async sllines_select(ss, tools) {
            console.log("sllines_select", ss);

            let state = this.sllines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                // state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.dateref = this.$moment.unix(state.item.dateref * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.datedepart = this.$moment.unix(state.item.datedepart * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }
        },


        async bllines_load(offset, limit, page) {

            this.bllines.busy = true;

            let variables = {
                selected: this.cleanit(this.selection),
                allocate: true
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                                mutation tickets_allocated($selected: [Ticket_input], $allocate: Boolean, $apply: Boolean) {
                                    tickets_allocated(selected: $selected, allocate: $allocate, apply: $apply) {
                                        id
                                        dateissued
                                        type
                                        locator
                                        carrier_id
                                        ticketno
                                        passenger
                                        datetravel
                                        routing
                                        flightno
                                        class
                                        fare
                                        tax
                                        total
                                        blac
                                        slac
                                        eventcode
                                        agent
                                        invoiceno
                                        status
                                        updated_by
                                        updated_at
                                    }
                                }
                        `,
                    variables,
                });
                // this.data = response.data.tickets_allocated
                this.bllines.items = [];
                for (var i = 0; i < response.data.tickets_allocated.length; ++i) {
                    let item = response.data.tickets_allocated[i]
                    item.bspref = item.ticketno
                    this.bllines.items.push({
                        id: item.id,
                        line: (i + 1).toString(),
                        blac: item.blac,
                        slac: item.slac,
                        yourref: item.yourref,
                        eventcode: item.eventcode,
                        datetravel: item.datetravel,
                        ticketno: item.ticketno,
                        bspref: item.ticketno,
                        passenger: item.passenger,
                        route: item.routing,
                        qty: "1",
                        costexvat: item.fare,
                        taxes: item.tax,
                        costtotal: item.total,
                        status: item.status,
                        updated_by: item.updated_by,
                        updated_at: item.updated_at,
                        invoiceno: item.invoiceno,
                    })
                }
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }





            this.bllines.busy = false;
        },

        async bllines_click(a, ss) {
            console.log("bllines_click", a, ss);

            let state = this.bllines;

            switch (a) {

                case "go":
                    this.component = null;
                    await this.bllines_load();
                    break;

                case "save":
                    await this.bllines_saveit()
                    break;

            }
        },
        async bllines_select(ss, tools) {
            console.log("bllines_select", ss);

            let state = this.bllines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                this.datetravel = this.$moment(state.item.datetravel, "DD/MM/YYYY").utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }
        },
        async bllines_total(f) {
            console.log('bllines_total', f)
            let found = f.find(o => o.key == 'amount')
            if (found) {
                this.total = found.total
            }

        },


        async saveit() {

            let variables = {}
            let rows = []

            let operation = this.reasontype //[this.tabindex - 1]
            this.message = ""
            console.log('saveit', this.reasontype)

            switch (operation) {

                case "allocated":
                    this.busy = true;
                    variables.selected = this.cleanit(this.allocation.items)
                    variables.apply = this.applyzhold == 1 ? true : false
                    variables.allocate = this.applyallocate == 1 ? true : false

                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_allocated($selected: [Ticket_input], $allocate: Boolean, $apply: Boolean) {
                                    tickets_allocated(selected: $selected, allocate: $allocate, apply: $apply) {
                                        id
                                        dateissued
                                        type
                                        locator
                                        carrier_id
                                        ticketno
                                        passenger
                                        datetravel
                                        routing
                                        flightno
                                        class
                                        fare
                                        tax
                                        slac
                                        eventcode
                                        agent
                                        invoiceno
                                        status
                                    }
                                }
                        `,
                            variables,
                        });
                        // this.message = "<span class='text-primary'>Posted it.</span>";
                        this.allocation.items = response.data.tickets_allocated

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }

                    this.busy = false;
                    break;

                case "sales":
                    this.busy = true;
                    for (var j = 0; j < this.sllines.items.length; j++) {
                        let row = this.sllines.items[j]
                        rows.push(row);
                    }
                    variables.rows = rows
                    variables.apply = true
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_sales($rows: [SLTransactionitem_input], $apply: Boolean) {
                                    tickets_sales(rows: $rows, apply: $apply) {
                                        id
                                        line
                                        slac
                                        eventcode
                                        yourref
                                        ticketno
                                        passenger
                                        route
                                        datetravel
                                        qty
                                        priceexvat
                                        taxes
                                        saleexvat
                                        fees
                                        subtotalexvat
                                        salevat
                                        saletotal
                                        updated_by
                                        updated_at
                                        invoiceno
                                        status
                                    }
                                }
                        `,
                            variables,
                        });
                        // this.message = "<span class='text-primary'>Posted it.</span>";
                        this.sllines.items = response.data.tickets_sales

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    this.busy = false;
                    break;

                case "costs":
                    this.busy = true;
                    for (var j = 0; j < this.bllines.items.length; j++) {
                        let row = this.bllines.items[j]
                        rows.push(row);
                    }
                    variables.rows = rows
                    variables.apply = true
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_costs($rows: [BLTransaction_input], $apply: Boolean) {
                                    tickets_costs(rows: $rows, apply: $apply) {
                                        id
                                        line,
                                        blac
                                        slac
                                        yourref
                                        eventcode
                                        datetravel
                                        ticketno
                                        passenger
                                        route
                                        qty
                                        costexvat
                                        taxes
                                        costtotal
                                        updated_by
                                        updated_at
                                        invoiceno
                                        status
                                    }
                                }
                        `,
                            variables,
                        });
                        // this.message = "<span class='text-primary'>Posted it.</span>";
                        this.bllines.items = response.data.tickets_costs

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    this.busy = false;
                    break;

                case "emds":
                    this.activesheet.busy = true;
                    variables.rows = this.cleanit(this.sheets)
                    variables.apply = true
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_emds($rows: [FilePreview_input], $apply: Boolean) {
                                    tickets_emds(rows: $rows, apply: $apply) {
                                        sheet
                                        fields
                                        items
                                        type
                                    }
                                }
                        `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";

                        this.sheets = response.data.tickets_emds
                        this.activesheet.fields = JSON.parse(response.data.tickets_emds[0].fields);
                        this.activesheet.items = JSON.parse(response.data.tickets_emds[0].items);
                        let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                        if (find) {
                            find.label = response.data.tickets_emds[0].sheet
                        }
                        this.posted = true

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    this.activesheet.busy = false;
                    break;

                case "refunds":
                    this.activesheet.busy = true;
                    variables.rows = this.cleanit(this.sheets)
                    variables.apply = true
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_refunds($rows: [FilePreview_input], $apply: Boolean) {
                                    tickets_refunds(rows: $rows, apply: $apply) {
                                        sheet
                                        fields
                                        items
                                        type
                                    }
                                }
                        `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";

                        this.sheets = response.data.tickets_refunds
                        this.activesheet.fields = JSON.parse(response.data.tickets_refunds[0].fields);
                        this.activesheet.items = JSON.parse(response.data.tickets_refunds[0].items);
                        let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                        if (find) {
                            find.label = response.data.tickets_refunds[0].sheet
                        }
                        this.posted = true

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    this.activesheet.busy = false;
                    break;

                case "other":
                    this.activesheet.busy = true;
                    variables.rows = this.cleanit(this.sheets)
                    variables.apply = true
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation tickets_other($rows: [FilePreview_input], $apply: Boolean) {
                                    tickets_other(rows: $rows, apply: $apply) {
                                        sheet
                                        fields
                                        items
                                        type
                                    }
                                }
                        `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";

                        this.sheets = response.data.tickets_other
                        this.activesheet.fields = JSON.parse(response.data.tickets_other[0].fields);
                        this.activesheet.items = JSON.parse(response.data.tickets_other[0].items);
                        let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                        if (find) {
                            find.label = response.data.tickets_other[0].sheet
                        }
                        this.posted = true

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    this.activesheet.busy = false;
                    break;
            }


        },

        async preview(data) {
            this.activesheet.busy = true;
            this.message_sheet = null
            this.message = null

            let variables = {
                data: JSON.stringify(this.fileUpload),
                state: this.state,
                type: this.sourcetype
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query file_preview($data: String, $state: String, $type: String) {
                            file_preview(data: $data, state: $state, type: $type) {
                                sheet
                                fields
                                items
                                type
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.file_preview[0].type == this.sourcetype) {
                    this.sheets = response.data.file_preview
                    this.activesheet.fields = JSON.parse(response.data.file_preview[0].fields);
                    this.activesheet.items = JSON.parse(response.data.file_preview[0].items);
                    this.activesheet.loaded = this.activesheet.items
                    let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                    if (find) {
                        find.label = response.data.file_preview[0].sheet
                    }
                    this.posted = false

                } else {
                    this.message_sheet = "Sheet could not be loaded, cannot load a sheet of type '" + response.data.file_preview[0].type + "' for '" + this.sourcetype + "' source processing.";
                }

            } catch (error) {
                console.log(error);
            }
            this.activesheet.busy = false;

        },
        async emd_click(a, ss) {

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;

                case "discard":
                case "go":
                    this.component = null;
                    this.state = null
                    this.preview();
                    break;

                case "error":
                case "missing":
                case "pending":
                case "void":
                case "invoiced":
                    this.state = a
                    this.message_sheet = null
                    this.activesheet.items = this.activesheet.loaded.filter(o => o.state == a.charAt(0).toUpperCase() + a.slice(1))
                    if (this.activesheet.items.length == 0) {
                        this.message_sheet = "Hmmm, looks like there are no rows marked with a state of '" + a + "''"
                    }
                    break;
            }
        },

        async emd_select(ss, tools) {
            console.log("emd_select", ss);

            let state = this.emd;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "textsize",
                    "error",
                    "missing",
                    "pending",
                    "void",
                    "invoiced",
                    "export",
                    "download",
                    "copy",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async refund_click(a, ss) {
            console.log("refund_click", a, ss);

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    this.state = null
                    this.preview();
                    break;
                case "credited":
                case "pending":
                case "missing":
                case "error":
                    this.state = a
                    this.message_sheet = null
                    this.activesheet.items = this.activesheet.loaded.filter(o => o.state == a.charAt(0).toUpperCase() + a.slice(1))
                    if (this.activesheet.items.length == 0) {
                        this.message_sheet = "Hmmm, looks like there are no rows marked with a state of '" + a + "''"
                    }
                    break;
            }
        },
        async refund_select(ss, tools) {
            console.log("refund_select", ss);

            let state = this.refund;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "textsize",
                    "credited",
                    "pending",
                    "missing",
                    "hold",
                    "error",
                    "export",
                    "download",
                    "copy",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async other_click(a, ss) {
            console.log("other_click", a, ss);

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    this.preview();
                    break;
                case "clear":
                    this.state = ""
                    break;
                case "invoiced":
                case "missing":
                case "zhold":
                    this.state += "," + a
                    break;
                // case "error":
                //     this.state = a
                //     this.message_sheet = null
                //     this.activesheet.items = this.activesheet.loaded.filter(o => o.state == a.charAt(0).toUpperCase() + a.slice(1))
                //     if (this.activesheet.items.length == 0) {
                //         this.message_sheet = "Hmmm, looks like there are no rows marked with a state of '" + a + "''"
                //     }
                //     break;
            }
        },
        async other_select(ss, tools) {
            console.log("other_select", ss);

            let state = this.refund;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "textsize",
                    "invoiced",
                    "missing",
                    "zhold",
                    "ban",
                    "export",
                    "download",
                    "copy",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        scrollToRow(index) {
            // let tbody = this.$refs['sllines']
            // let tbody = this.$refs['sllines'].$el.querySelector('tbody')
            // let row = tbody.querySelectorAll('tr')[index]
            // row.scrollIntoView()
        },
    },
};
</script>